import React, { Component } from "react";
import $ from "jquery";

class Refahi extends Component {
  constructor(props) {
    super(props);
    console.log("Votes Constructor");
  }
  state = {
    errorMessage: "",
    stepNo: 1,
    isVote: true,
    votePermit: false,
  };
  componentDidMount() {
    this.props.getAllCandidate();
    this.checkVotePermit();
  }
  render() {
    const Candidate_Active = this.props.candidateJson.map((e) => (
      <div
        key={e.ID}
        className="col-12 mb-2 bg-light dvCandidate"
        data-target={e.ID}
      >
        <div className="w-100 rounded p-1">
          <div className="row">
            <div className="col-2 m-auto checkbox">
              <label className="containerCustom">
                <input
                  type="radio"
                  value={e.ID}
                  onClick={() => this.selectCandidate(e.ID, this)}
                  name="Candidate"
                ></input>
                <span className="checkmark"></span>
              </label>
              {/* <input type="radio" name='Candidate'  /> */}
            </div>
            <div className="col-10">
              <img
                alt={e.Full_Name}
                src={e.Image}
                className="img-64 rounded-circle ml-2"
              />
              <span className="bg-dark text-white wp-text-small rounded p-1">
                کدپرسنلی: {e.Code}
              </span>
              <div className="title mt-1">
                <strong>{e.Full_Name}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
    const myCandidate = this.props.candidateJson.map((e) => (
      <li key={e.ID} className={"Array-item readClass"}>
        <img
          alt={e.Full_Name}
          src={e.Image}
          className="img-64 rounded-circle ml-2"
        />
        <span className="bg-dark text-white wp-text-small rounded-0 p-1">
          کد پرسنلی: {e.Code}
        </span>
        <span className="bg-light text-dark wp-text-small rounded-0 p-1">
          نام نماینده: {e.Full_Name}
        </span>
      </li>
    ));
    if (this.state.isVote === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <p className="mt-3 mb-0">
              <span className="bg-danger text-white px-2">اطلاعیه</span>
            </p>
            <div className="table-responsive bg-dark text-white p-2">
              <p className="text-justify mb-0">
                انتخابات به صورت الکترونیکی برگزار خواهد شد و صرفاً همکاران
                قرارداد سالکو امکان شرکت در انتخاب را دارند.
              </p>
              <p className="text-justify mb-0">
                در انتخاب خود دقت نمایید بعد از ثبت رأی امکان حذف و تغییر آن
                وجود ندارد.
              </p>
              <p className="text-justify text-center my-2">
                <span className="bg-primary font-weight-bold">
                  زمان برگزاری:
                </span>{" "}
                یکشنبه 15 بهمن ماه 1402 از ساعت 8 تا 13
              </p>
              {myCandidate}
            </div>
            <div className="text-left mt-2">
              <button onClick={this.toggleVote} className="btn btn-success">
                <span>شرکت در انتخابات</span>
              </button>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      if (this.state.stepNo === 1) {
        return (
          <React.Fragment>
            <div className="w-100 body-padding">
              <div className="item">
                <p className="wp-header bg-dark px-2">
                  گزینه مورد نظر خود را انتخاب کنید.
                </p>
                <div className="row justify-content-center">
                  <div className="col-12">
                    <ul className="Array p-0 mb-2">
                      {Candidate_Active.length === 0 ? (
                        <li className="Array-item">
                          <div className="title">
                            کاندیدی برای انتخاب وجود ندارد.
                          </div>
                        </li>
                      ) : (
                        Candidate_Active
                      )}
                    </ul>
                    <div className="text-left">
                      <button
                        onClick={this.toggleVote}
                        className="btn btn-danger mr-2"
                      >
                        <span>انصراف</span>
                      </button>
                      {this.state.votePermit === true ? (
                        <button
                          className="btn btn-success mr-2"
                          onClick={() => this.submitVote()}
                        >
                          <span>ثبت رأی</span>
                        </button>
                      ) : (
                        <button className="btn btn-success mr-2" disabled>
                          <span>ثبت رأی</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    }
  }
  checkVotePermit = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/check-user-vote`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            this.setState({ candidateJson: null });
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ votePermit: true });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  toggleVote = () => {
    this.setState({ isVote: !this.state.isVote });
  };
  selectCandidate = (id, e) => {
    if (id !== null) {
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue !== null && getValue.includes(id)) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      }
    }
  };
  submitVote = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var selectCandidateID = 0;
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        if (item.classList.contains("active") === true) {
          selectCandidateID = $(item).attr("data-target");
        }
      }
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Candidate", selectCandidateID);

      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-electronic-vote`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // this.toggleBlocking();
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.props.toggleErrorMessage(myObject.message);
              this.props.toggleError();
              this.toggleVote();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      const errorMessage =
        "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default Refahi;
